// Vendors
import React from 'react';
// Constants
import {
  LINE_SEPARATOR_PROPS,
  NUMBER_STEPS_PROPS,
  TITLE_STEP_PROPS,
} from 'constants/skeleton.constants';
// Components
import { SkeletonComponent } from '@openbank/ziniaweb-ui-components';
// Styles
import { 
  LayoutHeaderSkeletonComponentContainer, 
  LayoutHeaderStepsSkeletonContainer 
} from './layout-header-skeleton.component.styled';

const LayoutHeaderSkeletonComponent = (): React.JSX.Element => {
  return (
    <LayoutHeaderSkeletonComponentContainer>
      <LayoutHeaderStepsSkeletonContainer>
        <SkeletonComponent {...TITLE_STEP_PROPS} />
        <SkeletonComponent {...NUMBER_STEPS_PROPS} />
      </LayoutHeaderStepsSkeletonContainer>
      <SkeletonComponent {...LINE_SEPARATOR_PROPS} />
    </LayoutHeaderSkeletonComponentContainer>
  );
};

export { LayoutHeaderSkeletonComponent };
